module.exports = __webpack_public_path__ + "static/img/6.b3c1860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/6.png
// module id = 8xen
// module chunks = 3